import { Component } from 'react';
import { connect } from 'react-redux';

import ClubMembershipDetails from 'club/receipt/components/ClubMembershipDetails';
import CustomerDetails from 'club/receipt/components/CustomerDetails';
import ClubSummary from 'club/signup/components/ClubSummary';
import MobileToggleSummary from 'club/signup/components/MobileToggleSummary';
import { CheckoutLayout, Logo, NeedHelp } from 'common/components/layout';
import { getMessage } from 'common/helpers/miscHelper';
import { getClubMembership } from 'redux/clubMemberships/actions';
import { getNextClubPackageByClubId } from 'redux/clubPackages/actions';
import { getClubPackageByClubId } from 'redux/clubPackages/reducers';

import GiftMessage from './components/GiftMessage';
import ShippingInstructions from './components/ShippingInstructions';

class Receipt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSummaryVisibleOnMobile: false
    };
  }

  componentDidMount() {
    const { props } = this;
    props.getClubMembership(props.match.params.id);
  }

  toggleMobileSummary = () => {
    const { isSummaryVisibleOnMobile } = this.state;
    this.setState({ isSummaryVisibleOnMobile: !isSummaryVisibleOnMobile });
  };

  render() {
    const { clubMembership, settings, customer, clubPackage } = this.props;
    const { isSummaryVisibleOnMobile } = this.state;
    if (!settings.data || !clubMembership) {
      return (
        <CheckoutLayout title="Club Receipt" loading>
          &nbsp;
        </CheckoutLayout>
      );
    }
    const showAdjustShipment = clubMembership.clubType === 'Subscription';
    return (
      <CheckoutLayout title="Club Receipt">
        <MobileToggleSummary
          onToggleMobile={this.toggleMobileSummary}
          settings={settings}
          showAdjustShipment={showAdjustShipment}
          clubMembership={clubMembership}
        />
        <div className="c7-checkout">
          <ClubSummary
            club={clubMembership.club}
            clubMembership={clubMembership}
            clubPackage={clubPackage}
            isSummaryVisibleOnMobile={isSummaryVisibleOnMobile}
            page="Receipt"
            settings={settings}
          />
          <div className="c7-checkout__main">
            <div className="c7-checkout__header">
              <Logo />

              <h2>Thank you {customer.data && customer.data.firstName}!</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: getMessage('Club Receipt Message', settings)
                }}
              />
            </div>

            <div className="c7-account__order-detail__customer-details">
              <ClubMembershipDetails clubMembership={clubMembership} />
              <CustomerDetails
                clubMembership={clubMembership}
                settings={settings}
                customer={customer}
              />
              <GiftMessage clubMembership={clubMembership} />
              <ShippingInstructions clubMembership={clubMembership} />

              <NeedHelp
                type="Club"
                customer={customer.data}
                hasContinueShopping={false}
                settings={settings}
              />
            </div>
          </div>
        </div>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let clubPackage;
  const clubMembership =
    state.clubMembership.data &&
    state.clubMembership.data[ownProps.match.params.id];
  if (clubMembership) {
    clubPackage = getClubPackageByClubId(
      state.clubPackage,
      clubMembership.club.id
    );
  }
  return {
    clubMembership,
    clubPackage,
    settings: state.setting,
    customer: state.customer
  };
};

export default connect(mapStateToProps, {
  getClubMembership,
  getNextClubPackageByClubId
})(Receipt);
